// extracted by mini-css-extract-plugin
module.exports = {"list":"LinkListGrid_list__7BR63","border":"LinkListGrid_border__5US9Q"};